/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Video_Encoding_StandardInputs */

const en_audio_description_export_status_video_encoding_standard = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoding video with AD audio (standard)...`)
};

const fr_audio_description_export_status_video_encoding_standard = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodage de la vidéo avec l'audio AD (standard)...`)
};

const de_audio_description_export_status_video_encoding_standard = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videocodierung mit AD-Audio (Standard)...`)
};

const it_audio_description_export_status_video_encoding_standard = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica video con audio AD (standard)...`)
};

const ru_audio_description_export_status_video_encoding_standard = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кодирование видео с аудиосигналом AD (стандартный)...`)
};

const es_audio_description_export_status_video_encoding_standard = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificación de vídeo con audio AD (estándar)...`)
};

const zh_cn2_audio_description_export_status_video_encoding_standard = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 AD 音频（标准）对视频进行编码……`)
};

const ja_audio_description_export_status_video_encoding_standard = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD オーディオ (標準) でビデオをエンコードしています...`)
};

const hi_audio_description_export_status_video_encoding_standard = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD ऑडियो (मानक) के साथ वीडियो एन्कोडिंग...`)
};

const pt_pt2_audio_description_export_status_video_encoding_standard = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificação de vídeo com áudio AD (padrão)...`)
};

/**
* | output |
* | --- |
* | "Encoding video with AD audio (standard)..." |
*
* @param {Audio_Description_Export_Status_Video_Encoding_StandardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_video_encoding_standard = /** @type {((inputs?: Audio_Description_Export_Status_Video_Encoding_StandardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Video_Encoding_StandardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_video_encoding_standard(inputs)
	if (locale === "de") return de_audio_description_export_status_video_encoding_standard(inputs)
	if (locale === "it") return it_audio_description_export_status_video_encoding_standard(inputs)
	if (locale === "ru") return ru_audio_description_export_status_video_encoding_standard(inputs)
	if (locale === "es") return es_audio_description_export_status_video_encoding_standard(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_video_encoding_standard(inputs)
	if (locale === "ja") return ja_audio_description_export_status_video_encoding_standard(inputs)
	if (locale === "hi") return hi_audio_description_export_status_video_encoding_standard(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_video_encoding_standard(inputs)
	return en_audio_description_export_status_video_encoding_standard(inputs)
});